/*MENU MOBILE*/
const mobileMenu = document.querySelector('#menu-mobile');
if (mobileMenu) {
  window.addEventListener('DOMContentLoaded', sizingMenu, false)
}
function sizingMenu() {
  var header = document.querySelector('header');
  if (header) {
    var offsetMenu = header.getBoundingClientRect().top + header.clientHeight;
    console.log(offsetMenu);
    var mobileMenu = document.querySelector('#menu-mobile');
    if (mobileMenu) {
      mobileMenu.style.setProperty('height', 'calc(100vh - ' + offsetMenu + 'px)');
      mobileMenu.setAttribute('offset', offsetMenu + 'px');
    }
  }
};
const burgerBtn = document.querySelector('#burger-btn');
if (burgerBtn) {
  burgerBtn.addEventListener('click', toggleMobileMenu, false);
}

function toggleMobileMenu() {
  this.classList.toggle('burger-open');
  var mobileMenu = document.getElementById('menu-mobile');
  if (mobileMenu) {
    if (!mobileMenu.classList.contains('open')) {
      var offsetMenu = mobileMenu.getAttribute('offset');
      document.body.style.setProperty('overflow', 'hidden');
      mobileMenu.style.setProperty('top', offsetMenu);
    }
    else {
      mobileMenu.style.setProperty('top', '-100vh');
      document.body.style.setProperty('overflow', 'visible');
      mobileMenu.scrollTo(0, 0);
    }
    mobileMenu.classList.toggle('open');
  }
};

const dropdownToggle = document.querySelector('#dropdown-toggle');
if (dropdownToggle) {
  dropdownToggle.addEventListener('click', toggleDropdownLanguage, false);
}
function toggleDropdownLanguage() {
  var dropdownMenu = document.getElementById('dropdown-menu');
  dropdownMenu.classList.toggle('dropdown-menu-open');

};
/*END MENU MOBILE*/

//SLIDER IMPORT
import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';

/*SLIDER HERO*/
const swiper = new Swiper('.swiper', {
  modules: [Autoplay, EffectFade],
  effect: 'fade',
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },


  // Default parameters
  slidesPerView: 1,
  spaceBetween: 0,
});
/*END SLIDER HERO*/

/*SLIDER 3 CARD*/
const swiper3 = new Swiper('.swiper3', {
  modules: [Pagination],

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },
  // Default parameters
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    // when window width is >= 768px
    768: {
      slidesPerView: 4,
      spaceBetween: 30
    }
  }
});
/*SLIDER 3 CARD*/